export const templatesReducer = (state = {loading: false, resulttemplate: null, templates: [], template: null, total: 0} , action) => {
    switch (action.type) {
        case 'TEMPLATE_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                templates: action.payload.templates,
                total: action.payload.total
            }
        case 'TEMPLATE_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                template: action.payload.template
            }
        case 'TEMPLATE_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resulttemplate: action.payload.message,
                template: action.payload.template,
                templates: [...state.templates, action.payload.template],
            }
        case 'TEMPLATE_WRONG_SUCCESS':
            return {
                ...state,
                loading: false,
                resulttemplate: action.payload.message
            }
        case 'TEMPLATE_EDIT_SUCCESS':
            if(action.payload.template){
                return {
                    ...state,
                    loading: false,
                    resulttemplate: action.payload.message,
                    template: action.payload.template,
                    templates: state.templates.map(template => template._id === action.payload.template._id ? action.payload.template : template),
                }
            }else{
                return {
                    ...state,
                    loading: false,
                    resulttemplate: action.payload
                }
            }
        case 'TEMPLATE_RESET_RESULT':
            return {
                ...state,
                resulttemplate: null
            }
        case 'TEMPLATE_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'TEMPLATE_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}
